let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
  {
    label: "运营商名称",
    props: "dealName",
    minWidth: 200,
  },
  {
    label: "电站名称",
    props: "stationName",
    minWidth: 180,
    tooltip: true,
  },
  {
    label: "电站地址",
    props: "stationAddr",
    minWidth: 180,
    tooltip: true,
  },
  {
    label: "电站ID",
    props: "stationNo",
    minWidth: 180,
  },
  {
    label: "充电桩数量",
    props: "totalPileCount",
    minWidth: 100,
  },
  {
    label: "异常桩数量",
    props: "errorPileCount",
    minWidth: 100,
  },
  {
    label: "资费（元）",
    props: "ttlVal",
    minWidth: 100,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      if (row.ttlVal) {
        return row.ttlVal;
      } else {
        return "0";
      }
    },
  },
  {
    label: "运营状态",
    props: "stationStatusName",
    minWidth: 120,
  },
  {
    label: "充电量",
    props: "totalChargeCount",
    minWidth: 100,
    sortable: true,
  },
];

// // 面包屑
pageConfig.listBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "router",
    name: "活动管理",
    router: "activityManagement",
  },

  {
    type: "title",
    name: "活动列表",
  },
];

// 详情的面包屑
pageConfig.detailBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "router",
    name: "活动管理",
    router: "activityManagement",
  },
  {
    type: "title",
    name: "发布活动",
  },
];

// 详情预览面包屑
pageConfig.preview = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "router",
    name: "活动管理",
    router: "activityManagement",
  },
  {
    type: "title",
    name: "详细信息",
  },
];

// 详情预览面包屑
pageConfig.previewUrl = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "router",
    name: "活动管理",
    router: "activityManagement",
  },
  {
    type: "title",
    name: "URL导入",
  },
];

// 列表-表格属性
pageConfig.tableConfig = {
  showSelection: true,
  showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 15, 20, 50],
};

var http = (rule, value, callback) => {
  const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;
  if (!reg.test(value)) {
    callback(new Error("请输入正确的网址"));
  } else {
    callback();
  }
};


pageConfig.rules = {
  activityTitle: [{ required: true, message: "请输入标题", trigger: "blur" }],
  activityText: [{ required: true, message: "请输入正文", trigger: "change" }],
  typeCode: [{ required: true, message: "请选择分类", trigger: "change" }],
  activityCover: [
    { required: true, message: "请选择封面图片", trigger: "change" },
  ],
  activityPublishTime: [
    { required: true, message: "请选择发布时间", trigger: "blur" },
  ],
  abs: [{}],
  activitySource: [
    { required: true, message: "请输入文章来源", trigger: "blur" },
  ],
  activitySourceUrl: [
    {
      required: true,
      validator: http,
      trigger: "blur",
    },
  ],
};

export default pageConfig;
